import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { EducationalBackgroudService } from 'src/app/core/services/educationalBackground.service';
import { CloseNotifComponent } from '../../../new-application/components/peso-form/close-notif/close-notif.component';
import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';

class CustomDateAdapter extends NativeDateAdapter {
  format(date: Date): string {
    return `${date.getFullYear()}`;
  }
}

@Component({
  selector: 'app-add-item-graduate',
  templateUrl: './add-item-graduate.component.html',
  styleUrls: ['./add-item-graduate.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: { dateInput: "YYYY" },
        display: {
          dateInput: "YYYY",
          monthYearLabel: "YYYY",
          dateA11yLabel: "LL",
          monthYearA11yLabel: "YYYY",
        },
      },
    },
  ],
})

export class AddItemGraduateComponent implements OnInit {

  isAttendedSeniorHigh: boolean = false;

  minDate: any;
  maxDate: any;

  currentDate: Date;

  addGraduateForm: FormGroup

  isGraduateItemBeingAdded: boolean = false;
  isGraduateDisabled: boolean = false;

  successMessage: string = ""
  errorMessage: string = ""

  constructor(private fb: FormBuilder,  @Inject(MAT_DIALOG_DATA) public data, private educationalBackgroundService: EducationalBackgroudService, private dialog: MatDialog) { 

    const axios = require("axios");
    const moment = require("moment");

    axios
      .get("https://worldtimeapi.org/api/timezone/Asia/Manila")
      .then((response) => {

        const currentDatetime = moment(response.data.datetime);
        const currentYear = currentDatetime.year();

        // Calculate minDate and maxDate based on the API response

        this.currentDate = currentDatetime.date()

        this.isAttendedSeniorHigh = data.isAttendedSeniorHigh

        if(this.isAttendedSeniorHigh == true){

          this.minDate = data.minDateSeniorHigh

        }else{

          this.minDate = data.minDateHighSchool

        }

        this.maxDate = new Date(currentYear + 0, 11, 31); 

      })
      .catch((error) => {
        return error
      });
  }

  dataPopUp = this.data

  ngOnInit(): void {

    this.addGraduateForm = this.fb.group({
      school: ['', Validators.required],
      program: ['', Validators.required],
      major: ['', Validators.required],
      fieldOfStudy: ['', Validators.required],
      thesisTitle: ['', Validators.required],
      yearAttended: ['', Validators.required]

    })
  }

  closeNotif(){

    this.dialog.open(CloseNotifComponent)
    
  }

  saveGraduate(){

    if(this.addGraduateForm.invalid){
      this.errorMessage = "Please fill up all required details";

      setTimeout(() => {
        this.errorMessage = ''; 
      }, 2000); 
    }else{

      this.isGraduateItemBeingAdded = true;
      this.isGraduateDisabled = true;
    
      const yearAttended = this.addGraduateForm.controls.yearAttended.value ? this.addGraduateForm.controls.yearAttended.value : this.addGraduateForm.controls.yearAttended.setValue(null)

      const yearAttendISO = new Date(yearAttended.getTime() - yearAttended.getTimezoneOffset() * 60000).toISOString()

      const data = {
        school: this.addGraduateForm.controls?.school.value || '',
        program: this.addGraduateForm.controls?.program.value || '',
        major: this.addGraduateForm.controls?.major.value || '',
        fieldOfStudy: this.addGraduateForm.controls?.fieldOfStudy.value || '',
        thesisTitle: this.addGraduateForm.controls?.thesisTitle.value || '',
        adviser: "",
        honors: "",
        yearAttended: yearAttendISO
      }
  
      this.educationalBackgroundService.addGraduateStudies(this.data.response.id, data).subscribe((response) => {
  
        this.successMessage = "Graduate item added"

        this.isGraduateItemBeingAdded = false;
        this.isGraduateDisabled = false;
    
        setTimeout(() => {
          this.dialog.closeAll()
        }, 2000)
  
      })
    }
  }

  // Undergraduate
  public onYearSelectedGraduate(date: Date, datepicker: MatDatepicker<Date>) {
    const normalizedYear = date.getFullYear();
    this.addGraduateForm.controls.yearAttended.setValue(
      new Date(normalizedYear, 12, 0)
    );
    datepicker.close();
  }

}
